module.exports = new __parcel__URL__("horse.a168b80e.jpg").toString();